import { CheckCircle2, AlertTriangle } from "lucide-react";
import CrudTab from "@/components/CrudTab";
import { useResource } from "@/lib/api";

const FIELDS = [
  { key: "name", label: "Name", type: "text" },
  { key: "share_pct", label: "Share %", type: "decimal" },
  { key: "active", label: "Active", type: "switch" },
];
const COLUMNS = [
  { key: "name", label: "Director" },
  { key: "share_pct", label: "Share %", right: true, render: (r) => <span className="font-mono">{r.share_pct}%</span> },
];

const ShareBadge = ({ total }) => {
  if (!total) return null;
  const ok = total.is_valid;
  return (
    <div data-testid="directors-share-total-badge"
      className={`flex items-center gap-2 px-3 py-2 border text-sm ${ok ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" : "border-amber-500/40 bg-amber-500/10 text-amber-300"}`}>
      {ok ? <CheckCircle2 className="h-4 w-4" /> : <AlertTriangle className="h-4 w-4" />}
      <span>
        Active shares total <span className="font-mono">{total.total}%</span>
        {total.equal ? " — equal shares, each director gets exactly one third" : ok ? "" : " — should be 100% (each share is divided by the total)"}
      </span>
    </div>
  );
};

export default function DirectorsTab() {
  const { data: total, reload } = useResource("/directors/share-total");
  return (
    <CrudTab table="directors" singular="Director" prefix="director" fields={FIELDS} columns={COLUMNS}
      blank={{ name: "", share_pct: "0", active: true }} onChange={reload} header={<ShareBadge total={total} />} />
  );
}
